import { render, staticRenderFns } from "./addfeature.vue.js?vue&type=template&id=b5f012ea!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addfeature.vue?vue&type=template&id=b5f012ea"
import script from "./addfeature.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addfeature.vue?vue&type=script&lang=js"
export * from "./addfeature.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addfeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports